/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Current_Trip_TitleInputs */

const vi_vehicle_current_trip_title = /** @type {(inputs: Vehicle_Current_Trip_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyến đang chạy`)
};

/**

* @param {Vehicle_Current_Trip_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_current_trip_title = /** @type {((inputs?: Vehicle_Current_Trip_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Current_Trip_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_current_trip_title(inputs)
});